module.exports = __webpack_public_path__ + "static/media/sneakpeak-04.1fcd47e3.jpg";